exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#OfferPrint {\n  color: #404950;\n  margin-bottom: 1rem; }\n  #OfferPrint .title {\n    font-size: 16px;\n    line-height: 1.2;\n    font-weight: 600;\n    padding: .5rem;\n    padding-top: unset; }\n  #OfferPrint .action-button.medium {\n    margin-top: .5rem;\n    background-color: #f2f5fe;\n    color: #484848;\n    width: 90%; }\n    #OfferPrint .action-button.medium:hover {\n      background-color: #f2f5fe;\n      color: #047bf8;\n      border: 1px solid #047bf8; }\n      #OfferPrint .action-button.medium:hover svg {\n        fill: #047bf8; }\n", ""]);

// exports
